export default __webpack_public_path__ + "static/O0007-d943d3e538d3b5ea35a569dcd729a1e8.png";